import BottomSheet from "../components/BottomSheet.js";
import SettingsForm from "../components/SettingsForm.js";
import FacebookSignInClient from "./FacebookSignInClient.js";
import GoogleSignInClient from "./GoogleSignInPopupClient.js";

const LoginDialog = (element, options = {}) => {
  const el = element;
  const opts = {
    ...options,
  };

  let settingsForm;
  let googleSignInClient;
  let facebookSignInClient;

  const handleLoginFormSubmit = (event, submitButton) => {
    event.preventDefault();
    switch (submitButton.id) {
      case "login-with-google-button":
        submitButton.classList.add("loading");
        googleSignInClient.login(
          (user) => {
            opts.onSuccessfulThirdPartyAuthentication(user);
            submitButton.classList.remove("loading");
          },
          (error) => {
            opts.onFailedThirdPartyAuthentication(error);
            submitButton.classList.remove("loading");
          }
        );
        break;
      case "login-with-facebook-button":
        submitButton.classList.add("loading");
        facebookSignInClient.login(
          (user) => {
            opts.onSuccessfulThirdPartyAuthentication(user);
            submitButton.classList.remove("loading");
          },
          (error) => {
            opts.onFailedThirdPartyAuthentication(error);
            submitButton.classList.remove("loading");
          }
        );
        break;
      case "login-with-email-button": {
        let email = checkLoginForm();
        if (email) {
          const loginWithEmailButton = el.querySelector("#login-with-email-button");
          if (loginWithEmailButton) loginWithEmailButton.disabled = true;
          opts.onLoginWithEmail(email).then(() => {
            if (loginWithEmailButton) loginWithEmailButton.disabled = false;
          });
        }
        break;
      }
    }
  };

  const checkLoginForm = () => {
    const email = settingsForm.validateEmail(settingsForm.form.email)?.trim();
    const loginWithEmailButton = el.querySelector("#login-with-email-button");
    if (email && email.length > 0) {
      if (loginWithEmailButton) loginWithEmailButton.disabled = false;
      return email;
    } else {
      if (loginWithEmailButton) loginWithEmailButton.disabled = true;
      return false;
    }
  };

  const component = BottomSheet(el, {
    componentName: "LoginDialog",
    onOpen: async (googleClientId, facebookAppId) => {
      settingsForm = SettingsForm(el.querySelector("#login-settings-form"), {
        onSubmit: (event, submitButton) => handleLoginFormSubmit(event, submitButton),
      }).mount();
      settingsForm.on("email", "input blur", () => {
        checkLoginForm();
      });
      settingsForm.setValue("email", "");
      settingsForm.enable();

      el.querySelectorAll(".social-sign-in-buttons button").forEach((button) => {
        button.addEventListener("click", (event) => handleLoginFormSubmit(event, button));
      });

      if (!googleSignInClient) {
        googleSignInClient = GoogleSignInClient(googleClientId);
      }
      if (!facebookSignInClient) {
        facebookSignInClient = FacebookSignInClient(facebookAppId);
      }

      // Preload both SDKs to avoid popup blocking on first click
      // This ensures the SDKs are loaded before user interaction
      try {
        await Promise.all([googleSignInClient.preload(), facebookSignInClient.preload()]);
      } catch (error) {
        if (process.env.NODE_ENV === "development") console.warn("Error preloading social sign-in clients", error);
        settingsForm.form.querySelector(".social-sign-in-buttons").classList.add("hidden");
      }

      checkLoginForm();
    },
    onCloseFinished: async () => {
      if (settingsForm) {
        settingsForm.unmount();
        settingsForm.form.querySelector(".social-sign-in-buttons").classList.remove("hidden");
      }

      // Reset loading states on all buttons when dialog closes
      el.querySelectorAll(".social-sign-in-buttons button").forEach((button) => {
        button.classList.remove("loading");
        button.removeEventListener("click", (event) => handleLoginFormSubmit(event, button));
      });
    },
  });

  return component;
};

export default LoginDialog;
